import { mdiCheckBold, mdiMinus } from "@mdi/js";
import { Checkbox } from "antd";
import { CheckboxProps } from "antd/es/checkbox";
import { MaterialIcon } from "components/MaterialIcon";
import { useState } from "react";

interface CheckboxDisplayProps extends Omit<CheckboxProps, "onChange"> {
  value?: boolean;
  key?: string;
  isBuiltIn?: boolean;
  byRole?: boolean;
  isEditing?: boolean;
  onChange?: (checked: boolean) => void;
}

const CheckboxDisplay = ({
  value,
  isBuiltIn,
  byRole,
  isEditing,
  onChange,
  ...props
}: CheckboxDisplayProps) => {
  const [checked, setChecked] = useState<boolean>(value ?? false);

  if (!isEditing && checked && !isBuiltIn && !byRole) {
    return <MaterialIcon path={mdiCheckBold} color={"green"} size={0.825} />;
  }

  if (!isEditing && !checked && !isBuiltIn && !byRole) {
    return <MaterialIcon path={mdiMinus} color={"#d2d5d7"} size={1} />;
  }

  return (
    <Checkbox
      {...props}
      checked={checked}
      onChange={(e) => {
        setChecked(e.target.checked);
        onChange?.(e.target.checked);
      }}
    />
  );
};

export default CheckboxDisplay;
